const sdkUrlList = [
    {
        BASEURL: 'http://192.168.68.106:8081/sdkDialog/#/sdk/main',
    },
    {
        BASEURL: 'https://game.zaomeng.cc/sdkDialog/#/sdk/main',
    },
];

let sdkUrlArr;

sdkUrlArr = sdkUrlList[1]
let sdkUrl = sdkUrlArr.BASEURL
export default sdkUrl
